import { Link } from "react-router-dom";
import PublicLayout from "../../components/marketing/PublicLayout";
import { useMarketingLang } from "../../lib/useMarketingLang";
import { IMG } from "../../i18n/marketingImages";
import { ArrowRight, CheckCircle2 } from "lucide-react";

// Delt komponent for de tre opplevelses-sidene. Canal-siden viser i
// tillegg turkort med dagslister/priser (som på canalboats.no).
export default function ExperiencePage({ expKey, image }) {
  const { t } = useMarketingLang();
  const e = t.experiences[expKey];
  const isCanal = expKey === "canal";
  return (
    <PublicLayout>
      <section className="relative min-h-[420px] flex items-end">
        <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0F1A2B] via-[#0F1A2B]/70 to-[#0F1A2B]/30" />
        <div className="relative max-w-7xl mx-auto px-4 lg:px-8 py-14 lg:py-20 w-full">
          <div className="text-xs uppercase tracking-[0.42em] text-[#ECC974] mb-3">{t.nav.experiences}</div>
          <h1 className="text-3xl lg:text-5xl font-bold text-white leading-tight max-w-4xl">
            {e.title}
          </h1>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 lg:px-8 py-14 space-y-5">
        <p className="text-lg text-[#0F1A2B] leading-relaxed">{e.lead}</p>
        <p className="text-[#0F1A2B]/80 leading-relaxed">{e.body}</p>
        {"highlights" in e && (
          <ul className="grid sm:grid-cols-2 gap-2 mt-4">
            {e.highlights.map((h, i) => (
              <li key={i} className="flex items-start gap-2 text-sm text-[#0F1A2B]/85">
                <CheckCircle2 className="h-4 w-4 text-[#A57F39] mt-0.5 shrink-0" /> {h}
              </li>
            ))}
          </ul>
        )}
      </section>

      {isCanal && (
        <section className="bg-[#F8F7F2] py-14">
          <div className="max-w-7xl mx-auto px-4 lg:px-8">
            <h2 className="text-2xl lg:text-3xl font-bold text-[#0F1A2B] mb-8">{e.toursTitle}</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
              {e.tours.map((tour, i) => (
                <div
                  key={i}
                  data-testid={`exp-canal-tour-${i}`}
                  className="rounded-2xl border border-[#A57F39]/20 bg-white shadow-sm p-6 hover:shadow-xl transition"
                >
                  <div className="text-[10px] uppercase tracking-[0.32em] text-[#A57F39] mb-2">
                    {t.nav.canal}
                  </div>
                  <h3 className="text-lg font-bold text-[#0F1A2B] leading-snug mb-3">
                    {tour.title}
                  </h3>
                  <ul className="text-sm text-[#0F1A2B]/75 space-y-1 mb-4">
                    {tour.days.map((d, j) => (
                      <li key={j}>{d}</li>
                    ))}
                  </ul>
                  <div className="text-[#A57F39] font-bold">{tour.price}</div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      <section className="bg-[#0F1A2B] text-white py-14 text-center">
        <div className="max-w-3xl mx-auto px-4">
          <h2 className="text-2xl lg:text-3xl font-bold mb-6">
            {isCanal ? e.cta : t.nav.book}
          </h2>
          <Link
            to="/book"
            data-testid={`exp-${expKey}-book`}
            className="inline-flex items-center gap-2 rounded-full bg-[#A57F39] hover:bg-[#BD984D] transition text-white uppercase tracking-widest text-xs font-bold px-8 py-4"
          >
            {t.nav.book} <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </section>
    </PublicLayout>
  );
}
